import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { I18n } from "react-i18next";
import "../utils/i18n";

class RechercheResultTable extends PureComponent {
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row detail-space-top-title">
              <div className="span2 search-input-title">
                {t("detail.Massnahme")}
              </div>
              <div className="span1 search-input-title">{t("detail.Ort")}</div>
              <div className="span2 search-input-title">
                {t("detail.Gebaude")}
              </div>
              <div className="span2 search-input-title">
                {t("detail.OrgelbauerExperte")}
              </div>
            </div>
            {this.props.massnahmen
              .slice(0, this.props.limit)
              .map(
                ({
                  lat,
                  lng,
                  id,
                  massnahme,
                  gebaeude,
                  ort,
                  datum,
                  orgelbauer
                }) => (
                  <div className="row" key={id}>
                    <div className="span2">
                      {massnahme}, {datum}
                    </div>
                    <div className="span1">{ort}</div>
                    <div className="span2">{gebaeude}</div>
                    <div className="span2">{orgelbauer}</div>
                    <div className="span1 hslu-link">
                      <Link to={`/detail/${id}`}>
                        {t("navigation.Details")} &raquo;
                      </Link>
                    </div>
                  </div>
                )
              )}
          </div>
        )}
      </I18n>
    );
  }
}

export default RechercheResultTable;



// WEBPACK FOOTER //
// ./src/recherche/RechercheResultTable.js